import useAPI from '@/hooks/useAPI';
import TreatabilityRepository from '@/repositories/TreatabilityRepository';

const useTreatabilityInsight = (personId: string, enabled = true) => {
  const treatabilityRepository = TreatabilityRepository();

  return useAPI({
    queryKey: ['getTreatabilityData', personId],
    queryFn: async () => {
      return await treatabilityRepository.getTreatabilityData(personId);
    },
    enabled
  });
};

export default useTreatabilityInsight;
